import React, { ReactElement } from 'react';

import MenuItem from 'models/MenuItem';
import { Component as AwardStarIcon } from 'icons/icon-ui--award-star.svg';
import { Component as SaleTagIcon } from 'icons/icon-ui--sale-tag.svg';
import FavoriteActions from 'components/shared/Favorite';
import Picture from 'components/shared/Picture';
import SkuContent from './SkuContent';

type Props = {
  item: MenuItem;
  cartId?: number;
  hasFavoritesEnabled: boolean;
  isFavoritesGallery?: boolean;
  itemIndex?: number;
  showFavoritesAnnouncement?: boolean;
  openProductInNewTab?: boolean;
  onClick?: () => void;
};

function SkuItem({
  item,
  cartId,
  hasFavoritesEnabled,
  isFavoritesGallery = false,
  itemIndex,
  showFavoritesAnnouncement = false,
  openProductInNewTab = true,
  onClick = () => null,
}: Props): ReactElement {
  const {
    title,
    image_versions: imageVersions,
  } = item.sku;
  const { isOnSale } = item;
  return (
    <div
      key={item.sku.product_id}
      id={`recipe-${item.sku.product_id}`}
      className={`c-recipe ${isFavoritesGallery ? 'col-12 col-sm-6 col-lg-4' : ''}`}
    >
      <div role="none" className="c-recipe__container" onClick={onClick}>
        {item.premium && (
          <div className="c-recipe__summary-tag-premium">
            <AwardStarIcon />
            PREMIUM
          </div>
        )}
        <Picture versions={imageVersions} useHighResOnly alt={title} />
        {isOnSale && (
          <div className="c-recipe__summary-tag-sale">
            <SaleTagIcon />
            SALE!
          </div>
        )}
        <SkuContent
          item={item}
          cartId={cartId ?? null}
          openProductInNewTab={openProductInNewTab}
        />
      </div>
      {hasFavoritesEnabled && (
        <FavoriteActions
          item={item}
          isFavoritesGallery={isFavoritesGallery}
          itemIndex={itemIndex}
          showFavoritesAnnouncement={showFavoritesAnnouncement}
        />
      )}
    </div>
  );
}

export default SkuItem;
